import React from "react";
import { Navigate } from "react-router-dom";
import { hasAdminPermission } from "../api/adminAuthApi";

export default function PermissionRoute({ permission, children }) {
  return hasAdminPermission(permission) ? children : <Navigate to="/" replace />;
}
